import React, { useEffect, useState } from 'react';

import { Link } from 'react-router-dom';

import { Col, CardHeader, Row, Button } from 'reactstrap';
import InnerLoader from '../../../components/Common/InnerLoader';
import { getTeams } from '../../../actions/promotion/team';
import CreateTeamModal from './CreateTeamModal';

const TeamList = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [pageOffset, setPageOffset] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [teams, setTeams] = useState([]);
  const [pageSize, setPageSize] = useState(10);

  const getTeamsFunc = async () => {
    try {
      setIsLoading(true);

      const data = {
        pageOffset: pageOffset,
        pageSize: pageSize,
      };
      const res = await getTeams(data);

      setTotalPages(res?.data?.totalPages);
      setTeams(res?.data?.teams || []);
      setTimeout(() => {
        setIsLoading(false);
      }, 300);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getTeamsFunc();
  }, [pageOffset]);

  const pages = [...Array(totalPages)?.keys()];

  return (
    <>
      <CardHeader className="border-0">
        <Row className="pb-4 align-items-center">
          <Col sm></Col>
          <Col sm="auto">
            <div className="d-flex flex-wrap align-items-start">
              <CreateTeamModal
                submitHandler={() => {
                  getTeamsFunc();
                }}
              />
            </div>
          </Col>
        </Row>
      </CardHeader>
      <div className="table-responsive table-card">
        <table className="table table-nowrap table-centered align-middle mb-0">
          <thead className="bg-light text-muted">
            <tr>
              <th>Name</th>
              <th>Yearly Budget</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {(teams || []).map((team, key) => (
              <tr key={key}>
                <td>
                  <div className="d-flex align-items-center">
                    <div>
                      <h5 className="fs-13 mb-1">{team?.teamName}</h5>
                    </div>
                  </div>
                </td>

                <td>
                  <div className="d-flex align-items-center">
                    <div>
                      <h5 className="fs-13 mb-1">{`AED ${team?.yearlyBudget}`}</h5>
                    </div>
                  </div>
                </td>
                <td>
                  <div className="d-flex flex-row gap-3">
                    <CreateTeamModal
                      submitHandler={() => {
                        getTeamsFunc();
                      }}
                      team={team}
                    />
                    <Button size="sm" color="light">
                      View
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {totalPages > 1 ? (
        <div className="align-items-center mt-4 pt-2 justify-content-between row text-center text-sm-start">
          <div className="col-sm"></div>
          <div className="col-sm-auto mt-3 mt-sm-0">
            <ul className="pagination pagination-separated pagination-sm mb-0 justify-content-center">
              <li className={`page-item  ${pageOffset < 1 ? 'disabled' : ''}`}>
                <Link
                  to="#"
                  className="page-link"
                  onClick={() => {
                    setPageOffset(pageOffset - 1);
                  }}
                >
                  ←
                </Link>
              </li>

              {pages?.map((page, index) => {
                return (
                  <li
                    className={`page-item ${
                      pageOffset === index ? 'active' : ''
                    }`}
                  >
                    <Link
                      to="#"
                      className="page-link"
                      onClick={() => setPageOffset(index)}
                    >
                      {index + 1}
                    </Link>
                  </li>
                );
              })}

              <li className="page-item">
                <Link
                  to="#"
                  className={`page-link ${
                    pageOffset >= totalPages - 1 ? 'disabled' : ''
                  }`}
                  onClick={() => {
                    setPageOffset(pageOffset + 1);
                  }}
                >
                  →
                </Link>
              </li>
            </ul>
          </div>
        </div>
      ) : null}
      {isLoading ? <InnerLoader /> : null}
    </>
  );
};

export default TeamList;
